
import Vue from "vue";

export default Vue.extend({
  name: "SignupStatusChip",
  props: {
    completion: { type: [Number, String, Boolean], default: null },
    testId: { type: String, required: true }
  },
  computed: {
    incomplete(): boolean {
      // Only an explicit unfinished flag is evidence. Missing profile fields
      // and an unavailable completion flag must not label a complete account.
      return (
        this.completion === 0 ||
        this.completion === "0" ||
        this.completion === false
      );
    }
  }
});
